import { Column, Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';

import React, { useRef } from 'react';
import { Pressable, type LayoutChangeEvent, type StyleProp, type ViewStyle } from 'react-native';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

export const QUICK_ACTION_CARD_HEIGHT = 72;
export const QUICK_ACTION_CARD_MAX_HEIGHT = 132;

export function QuickActionCard({
  icon,
  title,
  subtitle,
  onPress,
  suffix,
  style,
  height,
  onMeasuredHeight,
  testID,
}: {
  icon: React.ReactNode;
  title: string;
  subtitle: React.ReactNode;
  onPress: () => void;
  suffix?: React.ReactNode;
  style?: StyleProp<ViewStyle>;
  height?: number;
  onMeasuredHeight?: (height: number) => void;
  testID?: string;
}) {
  const hasMeasured = useRef(false);

  return (
    <Pressable
      onPress={onPress}
      testID={testID}
      style={({ pressed }) => [
        { flex: 1, minHeight: QUICK_ACTION_CARD_HEIGHT, height, alignSelf: 'flex-start' },
        { opacity: pressed ? 0.72 : 1 },
        style,
      ]}
    >
      <Column
        onLayout={(event: LayoutChangeEvent) => {
          if (!hasMeasured.current) {
            hasMeasured.current = true;
            onMeasuredHeight?.(event.nativeEvent.layout.height);
          }
        }}
        gap="spacing.general.x1"
        padding="spacing.general.x4"
        style={{
          backgroundColor: theme.colors['surface.default'],
          borderRadius: theme.borderRadii['radius.lg'],
          borderWidth: 1,
          borderColor: theme.colors['surface.inverse.tertiary-neutral'],
          ...(height !== undefined ? { height: '100%' } : {}),
        }}
      >
        <Row alignItems="center" gap="spacing.general.x1">
          {typeof icon === 'string' ? <Text fontSize={16}>{icon}</Text> : icon}
          <Text fontWeight="600" fontSize={15} numberOfLines={1}>
            {title}
          </Text>
          {suffix}
        </Row>
        {typeof subtitle === 'string' ? (
          <Text fontSize={13} color="text.secondary" numberOfLines={1}>
            {subtitle}
          </Text>
        ) : (
          subtitle
        )}
      </Column>
    </Pressable>
  );
}
